import { Component } from 'react';
import { Alert } from 'react-bootstrap';

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(_error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="container" style={{ marginTop: "5rem" }}>
                    <Alert variant="danger">
                        <Alert.Heading>Something went wrong</Alert.Heading>
                        <p>Please refresh the page and try again.</p>
                    </Alert>
                </div>
            );
        }

        return this.props.children;
    }
}
